import React from "react";
import { ViewProps } from "react-native";

export const Raw: React.FC<ViewProps> = ({ children }) => <>{children}</>;
